import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col justify-center items-center h-[100dvh]">
      <h1 className="text-custom-primary-100 text-[48px] font-medium">
        NOT FOUND
      </h1>
      <Link to="/" className="hover:text-custom-primary-100">
        To Home
      </Link>
    </div>
  );
};

export default NotFound;
